import { CloseOutlined, CloudDownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import { App, Button, Space } from 'antd';
import { PdfPreviewModal } from './components/PdfPreviewModal.tsx';
import { printErrorShown, usePrinter } from './hooks/usePrinter.ts';
import { PrintButton } from './PrintButton.tsx';

type Props = {
  title: string;
  url: string;
  loading: boolean;
  blob: Blob | null;
  onDownload: () => void;
  onClose: () => void;
};

/** The PDF preview with Drucken, Download and Schließen; without a print path the download is the primary action. */
export const PdfPrintPreview = ({ title, url, loading, blob, onDownload, onClose }: Props) => {
  const { message } = App.useApp();
  const { canPrint, print } = usePrinter();

  const printPdf = async () => {
    if (!blob) {
      return;
    }
    try {
      await print(await blob.arrayBuffer(), 'a4', { title });
      message.success('Dokument wurde an den Drucker gesendet');
    } catch (e) {
      if (!printErrorShown(e)) {
        message.error('Beim Drucken ist ein Fehler aufgetreten');
      }
    }
  };

  return (
    <PdfPreviewModal
      title={title}
      url={url}
      loading={loading}
      footer={
        <Space orientation="horizontal">
          <PrintButton type="primary" icon={<PrinterOutlined />} onClick={printPdf}>
            Drucken
          </PrintButton>
          <Button type={canPrint ? undefined : 'primary'} icon={<CloudDownloadOutlined />} onClick={onDownload}>
            Download
          </Button>
          <Button icon={<CloseOutlined />} onClick={onClose}>
            Schließen
          </Button>
        </Space>
      }
      onClose={onClose}
    />
  );
};
